import axios from './axiosConfig';

const api = {
    // 内推登录
    login: (code) => axios.post('/authenticateUser/introducingEmployeeLogin', { code: code })
};
export default api;
